export const INBOX_FOLDER = 'inbox';
export const SENT_FOLDER = 'sent';
export const TRASH_FOLDER = 'trash';
export const CONTRACT_FOLDER = 'contract';
export const BACKUP_FOLDER = 'backup';


// export const HELP_DOC_URL = 'https://ai-fi.cc/help.html';
export const HELP_DOC_URL = 'https://ai-fi.cc/blog-single.html?article=principles-of-operation';

export const CONTACT_NAME_ME = 'Me';
export const CONTACT_NAME_ME_LOWERCASED = 'me';


// export const isSafari = ((window.navigator.vendor && window.navigator.vendor.toLowerCase() === 'apple computer, inc.') && (window.navigator.userAgent && window.navigator.userAgent.toLowerCase().indexOf('safari') !== -1))
export const isSafari = false;
export const userAgent = window.navigator.userAgent;
export const isAndroid = /(Android)/i.test(userAgent)
export const isIphone = /(iPhone|iPod)/i.test(userAgent)
export const isIpad = /(iPad)/i.test(userAgent)
export const isMobile = isIphone || isIpad || isAndroid;
// A mobile browser with ethereum we assume it's Metamask Browser
export const isMobileWeb3Browser = isMobile && (window.ethereum ? true : false);
// const isDesktopSafari = !isMobile && isSafari;
export const isUnsupportedBrowser = (isMobile ? !isMobileWeb3Browser : isSafari) && !window.isBrave;
export const isSupportedBrowser = (isMobile ? isMobileWeb3Browser : !isSafari) || window.isBrave;

export const homeScreenHasMenu = false;

export function mailAddressSubdomain(withDot=true) {
    return 'ai-mail' + (withDot ? '.' : '')
}

export function aifiDomain() {
    // return 'ai-fi.cc';
    return 'plexisign.net';
}

export function mailAddressDomain() {
    if (!window.appConfig) {
        return aifiDomain();
    }
    const domain = window.appConfig.domainName;
    if (domain === aifiDomain()) {
        return domain;
    }
    return mailAddressSubdomain() + domain;
}

export function mailAddressSuffix() {
    return '@' + mailAddressDomain();
    // const url = new URL(window.location);
    // return "@" + url.hostname;
}

export function mailAddressToSignalIdentity(address) {
    return address.toLowerCase().replaceAll('.', '!').replaceAll('@', '#');
}

export function signalIdentityToMailAddress(signalIdentity) {
    return signalIdentity.toLowerCase().replaceAll('!', '.').replaceAll('#', '@');

}

export const web3 = () => {
    if (window.magicWeb3) {
        return window.magicWeb3;
    }
}

export const isIOSApp = () => {

    let _isIOSApp = /PlexiSignApp/.test(navigator.userAgent) && !window.MSStream;
    if (!_isIOSApp) {
      const u = new URL(window.location.href);
      _isIOSApp = u.searchParams.get('platform') === 'ios';
    }
    return _isIOSApp;
};


export const RECOVER_WEB3_CONFIG_AUTOMATICALLY = false;
export const CONFIG_PLEXIMAIL_AUTOMATICALLY = true;
export const ENTERPRISE_FEATURES_ENABLED = false;
export const USE_DAG_FILE = false;
export const PLEXI_MAIL_VERSION = '1';
export const NEED_SUBSCRIPTION_MSG = 'You need to subscribe to PlexiSign to continue using it';
export const CONTRACT_INTRO_ENABLED = false;
export const SIMPLE_INITIALIZATION_MODE = true;
export const DEPRECATED_PASSWORD = 'this is disabled in simple mode';
export const DISPLAY_STORAGE_USAGE_ENABLED = false;
export const ATTACHMENT_SIZE_LIMIT = 100 * 1024 * 1024; // 100MB

/*
const isSafari = false;
const userAgent = window.navigator.userAgent;
const isAndroid = /(Android)/i.test(userAgent)
const isIphone = /(iPhone|iPod)/i.test(userAgent)
const isIpad = /(iPad)/i.test(userAgent)
const isMobile = isIphone || isIpad || isAndroid;
// A mobile browser with ethereum we assume it's Metamask Browser
const isMobileWeb3Browser = isMobile && (window.ethereum ? true : false);
// const isDesktopSafari = !isMobile && isSafari;
const isUnsupportedBrowser = (isMobile ? !isMobileWeb3Browser : isSafari) || !window.isBrave;
const isSupportedBrowser = (isMobile ? isMobileWeb3Browser : !isSafari) || window.isBrave;
*/